import { render, staticRenderFns } from "./CustomersIndex.vue?vue&type=template&id=612fc9e3&"
import script from "./CustomersIndex.vue?vue&type=script&lang=js&"
export * from "./CustomersIndex.vue?vue&type=script&lang=js&"
import style0 from "./CustomersIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports